import moment from 'moment';
import { KeyTaskConfiguration } from '../../../types/key-task-summarizer-type';
import { validateConfiguration } from '../../../utils/key-task-summarizer-utils';

type Translate = (id: string) => string;

export const createDefaultRequiredRules = (Translation: Translate) => [
  { required: true, message: Translation('component.form-required-text') },
];

export const createConfigurationRules =
  (getValues: () => KeyTaskConfiguration, Translation: Translate) => (field: keyof KeyTaskConfiguration) =>
    [
      ...createDefaultRequiredRules(Translation),
      {
        validator: (_rule: unknown, value: unknown) => {
          const error = validateConfiguration({ ...getValues(), [field]: value })[field];
          return error ? Promise.reject(new Error(Translation(error))) : Promise.resolve();
        },
      },
    ];

export type ConfigurationRules = ReturnType<ReturnType<typeof createConfigurationRules>>;

export const createEffectiveRangeRules = (Translation: Translate) => [
  {
    validator: (_rule: unknown, range: [Date | null, Date | null] | undefined) => {
      const [startDate, endDate] = range || [null, null];
      if (!startDate || !endDate || !moment(startDate).isValid() || !moment(endDate).isValid()) {
        return Promise.reject(new Error(Translation('component.form-required-text')));
      }
      if (moment(endDate).isBefore(startDate)) {
        return Promise.reject(new Error(Translation('component.form-date-compare')));
      }

      return Promise.resolve();
    },
  },
];
